import { mockRuntimeFeatures } from '@domgen/dgx-fe-config';
import { AppRuntimeFeatures } from '../../models/runtime/app-runtime-features.interface';

export const mockAppRuntimeFeatures: AppRuntimeFeatures = {
  ...mockRuntimeFeatures,
  smartFixHub: false,
  enablePromptEditingForSmartFix: false,
  enableVoiceCapture: true,
  CLAIMS_2_0: false,
  CLAIMS_2_0_HEATING: false,
  mmrFeedbackCapture: false,
};
